import {connect} from "react-redux";
import MetaOrdersPage from "./MetaOrdersPage";
import * as ViewActions from "../actions/ViewActions";
import {withRouter} from "react-router";

export default connect(null, {...ViewActions})(withRouter(MetaOrdersPage));